<template>
  <div class="article">
    <div class="title">洪子晴爵士出席亚太领袖会2025国际投资沙龙&并担任亚太经济领袖联合会永远荣誉主席</div>
    <div class="info">作者：晴天集团    发布于：2025-06-27 23:56</div>
    <p>2025年4月8日，由亞太領袖會暨亚太领袖论坛创始人、美国罗杰斯匹克球基金独董劳伦斯.余博士主办的亚太领袖会国际投资沙龙于深圳CFC长富金茂大厦盛大启幕。活动汇聚中国、新加坡、美国、韩国等30余位企业家、投资家、金融家及文体界代表，通过前沿观点碰撞与深度合作探讨，共拓亚太投资新机遇。</p>
    <p>主题演讲环节，亚太领袖会永远荣誉主席、著名慈善领袖、晴天集团主席、2023新加坡总统奖获奖者、洪子晴慈善基金主席洪子晴爵士、拿督斯里；摩根大通（新加坡）私行副总裁李翔女士等多位行业领军者，围绕科技创新、跨境资本、医疗健康及国际投资等热点议题展开深度分享。投资家美国哈里森基金苏菲·哈里森、韩国医学博士金学峰等嘉宾更从全球视角解析产融结合趋势。</p>
    <p>作为会议的重要环节，洪子晴爵士、拿督斯里因其在推动亚太地区投资发展及经济合作中所做出的卓越贡献，被正式授予 “亚太领袖会永远荣誉主席” 称号。这一殊荣不仅是对她个人成就的高度认可，也是“亚太领袖会”唯一女性拿到最高的荣誉，更标志着她在未来将肩负起更为重要的责任，继续引领亚太地区投资领域的创新与发展。</p>
    <p>亚太领袖会 2025 国际投资沙龙的成功举办，为亚太地区乃至全球的投资者搭建了一个高效的交流合作平台。而洪子晴爵士、拿督斯里的加入，无疑为亚太领袖会注入了新的活力与智慧，相信在洪子晴爵士、拿督斯里的带领下，亚太经济领袖联合会将在促进区域经济发展、推动国际投资合作等方面取得更为丰硕的成果。</p>
    <p>亚太经济领袖联合会汇聚了全球众多经济领袖和思想领袖，成员包括世界500强、中国500强及亚太区各行业卓越领袖等。具体如下： 创始人兼主席为劳伦斯·余博士，他同时也是APAC亚太领袖投资集团（迪拜）联席董事长、一带一路（非盟）银行创始人兼执行主席等。 名誉会长有陈永栽、李文正、王健林、霍震霆、张瑞敏等五十多位知名华商领袖。</p>
    <p>亚太领袖会2025国际投资沙龙参会嘉宾有：</p>
    <p>△亚太领袖会永远荣誉主席、著名慈善领袖、晴天集团主席、2023新加坡总统奖获奖者、洪子晴慈善基金主席洪子晴爵士、拿督斯里</p>
    <p>△亚太领袖会北美主席、美国十大家族哈里森基金执行主席、苏菲哈里森女士</p>
    <p>△亚太领袖会美中体育合作形象大使、NBA著名冠军球星、美国匹克球基金公司董事长卡洛斯.罗杰斯</p>
    <p>（Ambassador for US - China Sports Cooperation for APELUA）</p>
    <p>△亚太领袖会中华文化委员会主席、亚太全球私董会发起人、五行思维创始人火越先生</p>
    <p>△亚太领袖会副主席、香港宝声集团主席陈耀璋先生</p>
    <p>△香港著名收藏家、丝路城市大学筹办人张昌国先生</p>
    <p>△香港铜锣湾集团董事局主席 陈智先生</p>
    <p>△澳门世界华商基金会创始主席曾程本博士</p>
    <p>△中國城鄉融合發展聯盟副主席張國庆先生</p>
    <p>△全球总统御医联盟会长金学峰（韩国）</p>
    <p>特邀亞太领袖會海外財富管理团队.新加坡：</p>
    <p>摩根大通中国市场副总裁兼银行顾问李翔女士</p>
    <p>摩根大通私人银行新加坡副总裁王宁女士</p>
    <p>摩根大通私人银行财富咨询顾问唐怡莎女士</p>
    <p>4月10日，亚太领袖会永远荣誉主席、著名慈善领袖、投资人、晴天集团主席、2023新加坡总统奖获奖者、洪子晴慈善基金主席洪子晴爵士、拿督斯里与亚太经济领袖联合会创始人劳伦诗·余博士前往一汽物流（佛山）多式联运智慧产业园项目现场进行参观考察。</p>
    <p>洪子晴爵士在商业领域成绩斐然，身为著名慈善家、投资人，同时是美国上市公司的实际控制人，旗下业务广泛，涵盖多个重要领域。在参观过程中，洪子晴爵士在项目负责人的陪同下，详细了解了一汽物流（佛山）多式联运智慧产业园的整体规划。一汽物流（佛山）多式联运智慧产业园在这方面的探索和实践具有重要的示范意义。智能化的物流设施不仅能提高货物处理速度，增强物流服务的稳定性和可靠性，为企业创造更大的价值。</p>
    <img  src="@/assets/img/article/0629/1.webp" alt="">
    <p class="img-alt-content">著名慈善家、晴天集团董事局主席洪子晴爵士 、拿督斯里与嘉宾们围绕科技创新、国际资本、医疗健康及全球投资等热点议题展开深度分享</p>
    <img  src="@/assets/img/article/0629/2.webp" alt="">
    <p class="img-alt-content">著名慈善家、晴天集团董事局主席洪子晴爵士与嘉宾们围绕科技创新、国际资本、医疗健康及全球投资等热点议题展开深度分享 </p>
    <img  src="@/assets/img/article/0629/3.webp" alt="">
    <p class="img-alt-content">著名慈善家、晴天集团董事局主席洪子晴爵士获颁“亚太领袖会永远荣誉主席”称号</p>
    <img  src="@/assets/img/article/0629/4.webp" alt="">
    <p class="img-alt-content">著名慈善家、晴天集团董事局主席洪子晴爵士与亚太领袖会高层及嘉宾合影</p>
    <img  src="@/assets/img/article/0629/5.webp" alt="">
    <p class="img-alt-content">亚太领袖会永远荣誉主席洪子晴爵士参观考察一汽（佛山）多式联运智慧产业园项目</p>
    <img  src="@/assets/img/article/0629/6.webp" alt="">
    <p class="img-alt-content">亚太领袖会永远荣誉主席洪子晴爵士听取项目情况介绍并进行座谈交流</p>
    <img  src="@/assets/img/article/0629/7.webp" alt="">
    <p class="img-alt-content">亚太领袖会永远荣誉主席洪子晴爵士（居中）与亚太经济领袖联合会创始人劳伦诗·余博士（左一）及一汽（佛山）多式联运智慧产业园项目负责人合影</p>
    <img  src="@/assets/img/article/0629/8.webp" alt="">
    <p class="img-alt-content">亚太领袖会永远荣誉主席洪子晴爵士（居中）与与亚太经济领袖联合会创始人劳伦诗·余博士（左一）及一汽（佛山）多式联运智慧产业园项目高层合影</p>
    <img  src="@/assets/img/article/0629/9.webp" alt="">
    <p class="img-alt-content">亚太领袖会永远荣誉主席洪子晴爵士（居中）与与亚太经济领袖联合会创始人劳伦诗·余博士（左一）及一汽（佛山）多式联运智慧产业园项目高层合影</p>

  </div>
</template>

<script>
  export default {
    name: '1',
    components: {},
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  .article{
    width: 70%;
    margin: 20px auto;
    font-family: $font-family;
    .title{
      font-size: 1.4rem;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 60%;
      margin-left: 20%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 10px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }

    .img-alt-content{
      text-align: center;
      line-height: 1.3;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    .article{
      width: 90%;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 80%;
        margin-left: 10%;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        margin: 6px 0;
        color: #2f2e2e;
        padding-top: 5px;
        font-size: 0.8rem;
      }
      .img-alt-content{
        text-align: center;
        line-height: 1.3;
        margin: 6px 0;
        padding-top: 5px;
        padding-bottom: 15px;
        color: #2f2e2e;
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    .article{
      width: 100vw;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 20px auto;
      .title{
        padding-top: 10px;
        padding-bottom: 8px;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;
        text-align: center;
      }

      .info{
        height: 28px;
        line-height: 28px;
        border-bottom: 1px #e8e8e8 solid;
        margin: 0;
        text-align: center;
        font-size: 0.8rem;
      }

      p{
        font-size: $phone-content-font-size;
        color: #000000;
        line-height: 2;
        margin: 20px 0;
      }

      img{
        width: 100%;
        margin: 0;
      }

      .img-alt{
        text-align: center;
        line-height: 1;
        font-size: 0.7rem;
        margin: 6px 0;
        color: #666;
      }
    }
  }
</style>
